import { Suspense } from 'react';
import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';

//layouts
import { MinimalLayout, MainLayout, ZeroLayout } from './layouts';

//screens
import { ForgotPassword, Login, ResetPassword } from './features/auth';
import { GroupRegistration } from './features/groups';
import { SetupGroups } from './features/setup';
import GroupRegistrationConfirmation from './features/groups/views/GroupRegistrationConfirmation';
import { Home } from './features/home';

const authRoutes = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: 'reset-password',
        element: <ResetPassword />,
      },
    ],
  },
];

const mainRoutes = [
  {
    path: '/',
    children: [
      { index: true, element: <Home /> },
      { path: 'home', element: <Home /> },
    ],
  },
  {
    path: '/setup',
    children: [{ path: 'groups', element: <SetupGroups /> }],
  },
];

const zeroLayoutRoutes = [
  {
    path: '/groups',
    children: [
      { path: 'register', element: <GroupRegistration /> },
      { path: 'confirm', element: <GroupRegistrationConfirmation /> },
    ],
  },
];

const SuspenseLoading = () => {
  return (
    <div className="d-flex align-items-center flex-column vh-100 justify-content-center text-center py-3">
      <div className="text-muted font-size-xl text-center pt-3">Loading...</div>
    </div>
  );
};

const Routes = ({ loggedIn }) => {
  return (
    <Suspense fallback={<SuspenseLoading />}>
      <ReactRouterRoutes>
        <Route element={<MinimalLayout />}>
          {authRoutes.map((route, k) => (
            <Route key={k} {...route}>
              {route.children.map((child, k) => (
                <Route key={k} {...child} />
              ))}
            </Route>
          ))}
        </Route>
        <Route element={<MainLayout loggedIn={loggedIn} />}>
          {mainRoutes.map((route, k) => (
            <Route key={k} {...route}>
              {route.children.map((child, k) => (
                <Route key={k} {...child} />
              ))}
            </Route>
          ))}
        </Route>
        <Route element={<ZeroLayout loggedIn={loggedIn} />}>
          {zeroLayoutRoutes.map((route, k) => (
            <Route key={k} {...route}>
              {route.children.map((child, k) => (
                <Route key={k} {...child} />
              ))}
            </Route>
          ))}
        </Route>
      </ReactRouterRoutes>
    </Suspense>
  );
};

export default Routes;
